import React, { Fragment } from "react";
import { Pagina } from "../template/Template";
import { AuthContext } from "../../App";
import IconButton from "@material-ui/core/IconButton";
import { ExcelRenderer } from "react-excel-renderer";
import {
    reanaliseInsert,
    reanaliseFindByReaid,
    reanaliseDelete,
} from "../../services/ReanaliseService";
import {
    reanaliseItemInsert,
    reanaliseItemFindByReaid,
    reanaliseItemDeleteAll,
} from "../../services/ReanaliseItemService";
import { vereditoUsuarioImport } from "../../services/VereditoUsuarioService";
import { format } from "date-fns";
import { DataGrid } from "@material-ui/data-grid";
import Paper from "@material-ui/core/Paper";
import { ThemeProvider } from "@material-ui/core/styles";
import CloudUpload from "@material-ui/icons/CloudUpload";
import ImportExport from "@material-ui/icons/ImportExport";
import Undo from "@material-ui/icons/Undo";
import { Loading } from "../Loading";
import Tooltip from "@material-ui/core/Tooltip";

import { ShowMessageBox } from "../ShowMessageBox";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import { useStyles } from "../styles/StyleReanalise";
import { theme } from "../styles/Theme";

let severity = "success";
let msg = "";
let reaId;

export default function Reanalise() {
    let history = useHistory();
    const classes = useStyles();
    const { state: authState } = React.useContext(AuthContext);

    const Content = () => {
        const [operacao, setOperacao] = React.useState({
            upload: false,
            process: true,
            cancel: true,
        });

        const [listReanaliseItem, setListReanaliseItem] = React.useState([]);

        const [openSnackBar, setOpenSnackBar] = React.useState(false);
        const [openLoading, setOpenLoading] = React.useState(false);

        const fileHandler = (event) => {
            let fileObj = event.target.files[0];
            ExcelRenderer(fileObj, async (err, resp) => {
                setOpenSnackBar(false);
                setOpenLoading(true);

                if (err) {
                    msg = err;
                    severity = "fail";
                    setOpenSnackBar(true);
                    setOpenLoading(false);
                } else {
                    if (resp.cols.length !== 7) {
                        severity = "error";
                        msg = "Número de colunas invalido";
                        setOpenSnackBar(true);
                        setOpenLoading(false);
                        return;
                    }

                    for (let i = 0; i < resp.rows.length; i++) {
                        let item = resp.rows[i];

                        if (item.length === 0) {
                            // console.log("BREAK");
                            break;
                        }
                        if (i === 0) {
                            if (
                                item[1] === "Operador" &&
                                item[2] === "Truck ID" &&
                                item[3] === "Container" &&
                                item[4] === "Decisão" &&
                                item[5] === "Horário" &&
                                item[6] === "E-mail RF"
                            ) {
                                console.log("Gravou a reanalise");
                                const reanalise = {
                                    usu_id: authState.id,
                                    rea_dt_criacao: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
                                    rea_situacao: "Importado",
                                };
                                const result = await reanaliseInsert(reanalise);
                                reaId = result.data[0];
                            } else {
                                console.log("Erro nos items", item);
                                severity = "error";
                                msg = "Colunas estão com dados errados";
                                setOpenSnackBar(true);
                                setOpenLoading(false);
                                return;
                            }
                        }

                        if (i > 0) {
                            if (item[3] === undefined || item[2] === undefined) {
                                continue;
                            }

                            if (item[3].length === 0 || item[2].length === 0) {
                                continue;
                            }

                            if (item[2].trim().length === 0) {
                                continue;
                            }
                            if (item[3].trim().length === 0) {
                                continue;
                            }
                            const reanaliseItem = {
                                rea_id: reaId.rea_id,
                                rei_seq: i,
                                con_id: null,
                                rei_situacao: "Pendente",
                                rei_container: item[3].trim().toUpperCase(),
                                trk_id: item[2].trim().toUpperCase(),
                            };
                            if (process.env.REACT_APP_DEBUG_MODE === "True") {
                                console.log("Gravar Item Reanalise", reanaliseItem);
                            }
                            try {
                                const ret = await reanaliseItemInsert(reanaliseItem);
                                if (process.env.REACT_APP_DEBUG_MODE === "True") {
                                    console.log("Processou: " + JSON.stringify(ret));
                                }
                            } catch (err) {
                                console.log("Processou Erro: " + JSON.stringify(err));
                            }
                        }
                    }
                    const reaIdNum = reaId.rea_id;
                    // console.log(reaIdNum);
                    const result1 = await reanaliseFindByReaid(reaIdNum);
                    console.log(result1.data);
                    const result2 = await reanaliseItemFindByReaid(reaIdNum);
                    setListReanaliseItem(result2.data);
                    setOperacao({ upload: true, process: false, cancel: false });
                    msg = "Reanalise importada com sucesso";
                    severity = "success";
                    setOpenSnackBar(true);
                    setOpenLoading(false);
                }
            });
        };

        const processarReanalise = async () => {
            setOpenSnackBar(false);
            setOpenLoading(true);
            try {
                const reaIdNum = reaId.rea_id;
                await vereditoUsuarioImport(reaIdNum);
                setOperacao({ upload: false, process: true, cancel: true });
                setListReanaliseItem([]);

                setOpenSnackBar(true);
                setOpenLoading(false);
                setTimeout(function () {
                    history.push("/reanalise");
                }, 700);
                msg = "Reanalise processada com sucesso";
                severity = "success";
            } catch (error) {
                msg = "Erro no processamento";
                setOpenSnackBar(true);
                setOpenLoading(false);
            }
        };

        const deleteImportedReanalise = async () => {
            const dados = {
                rea_id: reaId.rea_id,
            };
            setOpenLoading(true);
            try {
                await reanaliseItemDeleteAll(dados);
                await reanaliseDelete(dados);
                setListReanaliseItem([]);
                setOperacao({ upload: false, process: true, cancel: true });

                setOpenSnackBar(true);
                setOpenLoading(false);
                setTimeout(function () {
                    history.push("/reanalise");
                }, 700);
                msg = "Reanalise removida com sucesso";
                severity = "success";
            } catch (error) {
                msg = "Erro ao processar exclusao";
                severity = "error";
                setOpenSnackBar(true);
                setOpenLoading(false);
            }
        };

        return (
            <Fragment>
                <div className={classes.box}>
                    <Loading open={openLoading} />
                    <ShowMessageBox
                        open={openSnackBar}
                        setOpen={setOpenSnackBar}
                        severity={severity}
                        msg={msg}
                    />
                    <Paper className={classes.boxPrancheta} elevation={7}>
                        <div className={classes.boxToolbar}>
                            <input
                                type="file"
                                onChange={fileHandler.bind(this)}
                                id="icon-button-file"
                                hidden
                                disabled={operacao.upload}
                            />
                            <label htmlFor="icon-button-file">
                                <Tooltip title="Carregar Planilha">
                                    <IconButton
                                        color="primary"
                                        component="span"
                                        disabled={operacao.upload}
                                    >
                                        <CloudUpload fontSize="large" />
                                    </IconButton>
                                </Tooltip>
                            </label>
                            <Tooltip title="Concluir Importação">
                                <IconButton
                                    color="primary"
                                    component="span"
                                    disabled={operacao.process}
                                    onClick={processarReanalise}
                                >
                                    <ImportExport fontSize="large" />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Remover Importação">
                                <IconButton
                                    color="primary"
                                    component="span"
                                    disabled={operacao.cancel}
                                    onClick={deleteImportedReanalise}
                                >
                                    <Undo fontSize="large" />
                                </IconButton>
                            </Tooltip>
                        </div>

                        <div className={classes.boxDataGrid}>
                            <ThemeProvider theme={theme}>
                                <DataGrid
                                    rows={listReanaliseItem}
                                    disableColumnMenu
                                    disableColumnReorder
                                    getRowClassName={(params) =>
                                        `super-app-theme--${params
                                            .getValue("rei_situacao")
                                            .replace(/ /g, "-")}`
                                    }
                                    sortModel={[
                                        {
                                            field: "rei_situacao",
                                            sort: "asc",
                                        },
                                    ]}
                                    columns={[
                                        {
                                            field: "rei_container",
                                            headerName: "Container",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            flex: 1,
                                            sortable: false,
                                        },
                                        {
                                            field: "rei_situacao",
                                            headerName: "Situação",
                                            headerClassName: "header_grid",
                                            type: "string",
                                            headerAlign: "center",
                                            width: 250,
                                        },
                                    ]}
                                />
                            </ThemeProvider>
                        </div>
                    </Paper>
                </div>
            </Fragment>
        );
    };

    return (
        <Fragment>
            <Pagina authState={authState} Content={Content} HeaderDesc="REANÁLISE" />
        </Fragment>
    );
}
